/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

export default {
    namespaced: true,
    state: () => ({
        profile: null,
    }),

    mutations: {
        setMemberProfile(state, profile) {
            state.profile = profile;
        },
    },
};
